import { useTranslation } from 'react-i18next';

import { getEventTriggeredOnState } from '@hotjar/heatmaps';
import { EmptyState } from '@hotjar/webapp/components/EmptyState';
import { useCurrentSite } from '@hotjar/site';
import { useTrack } from '@hotjar/webapp/hooks/useTrack';
import { EVENT_NAMES, EVENT_UI_POSITIONS } from '@hotjar/webapp/domains/heatmaps/tracking';
import { navigateToInstaller } from '@hotjar/webapp/domains/activation/routing';

import installTrackingCodeImage from '../../icons/install-tracking-code.svg';
import { EmptyPageMessageContainer } from './MessageContainer';

export const NotInstalled = (): JSX.Element | null => {
  const { t } = useTranslation('heatmaps');
  const { data: currentSite, isLoading } = useCurrentSite();
  const track = useTrack();

  if (isLoading || !currentSite?.id) return null;

  const onInstall = (): void => {
    navigateToInstaller(currentSite);
    track.click(
      EVENT_NAMES.INSTALL_TRACKING_CODE,
      EVENT_UI_POSITIONS.TC_PENDING_STATE,
      getEventTriggeredOnState(),
    );
  };

  return (
    <EmptyPageMessageContainer imgWidth={320}>
      <EmptyState
        img={installTrackingCodeImage}
        title={t('empty-state.not-installed.title')}
        subtitle={t('empty-state.not-installed.subtitle')}
        buttonText={t('empty-state.not-installed.action')}
        buttonKind="primary"
        onButtonClick={onInstall}
      />
    </EmptyPageMessageContainer>
  );
};
